<template>
  <div>
    <ul id="control_video" class="clearfloat">
      <button disabled>
        <Icon type="md-arrow-round-up" style="transform:rotate(-45deg);" />
      </button>
      <button>
        <Icon type="md-arrow-round-up" />
      </button>
      <button disabled>
        <Icon type="md-arrow-round-up" style="transform:rotate(45deg);" />
      </button>
      <button>
        <Icon type="md-arrow-round-up" style="transform:rotate(-90deg);" />
      </button>
      <button @click="btn" disabled>
        <Icon type="md-ionic" />
      </button>
      <button>
        <Icon type="md-arrow-round-up" style="transform:rotate(90deg);" />
      </button>
      <button disabled>
        <Icon type="md-arrow-round-up" style="transform:rotate(-135deg);" />
      </button>
      <button>
        <Icon type="md-arrow-round-up" style="transform:rotate(180deg);" />
      </button>
      <button disabled>
        <Icon type="md-arrow-round-up" style="transform:rotate(135deg);" />
      </button>
    </ul>
  </div>
</template>
<script>
import axios from "axios";
export default {
  methods: {
    btn() {
      axios
        .get(
          "http://120.77.112.76:6809/ptzController/directive.do?key=2161e23a-4d3b-4d1a-bf0a-cafd56f9c6f8&id=1"
        )
        .then(function(response) {
          console.log(response);
        })
        .catch(function(error) {
          console.log(error);
        });
    }
  }
};
</script>
<style>
#control_video {
  width: 210px;
  height: 210px;
}
#control_video button {
  float: left;
  width: 50px;
  height: 50px;
  border: none;
  border-radius: 50%;
  margin: 10px;
  text-align: center;
  font-size: 30px;
  color: #626262;
  outline: none;
  background: #f5f5f5;
}
#control_video button:disabled {
  color: #999999;
  background: #f5f5f5;
  cursor:no-drop
}
</style>


// WEBPACK FOOTER //
// src/components/video/control.vue